import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SettingsService } from '../../../core/settings/settings.service';

import { LoggingService } from '../../../../app/core/services/log.service';
import { AuthService } from "../../../../app/core/services/auth.service";
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import swal from 'sweetalert2';
import { S1UIService } from '@app/s1';

@Component({
    selector: 'app-activate',
    templateUrl: './activate.component.html',
    styleUrls: ['./activate.component.scss'],
    standalone: false
})
export class ActivateComponent implements OnInit {

    @ViewChild('formActivate') activateForm: NgForm;

    // string for errorMessage service
    msgTranslation;
    errorTranslation;
    errorMessage;
    styleInput = 'password';
    styleIcon = '';

    public account = {
      firstLoginToken: "",
      password: "",
    };

    constructor(
      public settings: SettingsService,
      private activeRoute: ActivatedRoute,
      private logger: LoggingService,
      private router: Router, 
      private authService: AuthService,
      private translate: TranslateService,
      private ui: S1UIService
    ) {
      this.errorTranslation =  this.translate.get('error');
      this.msgTranslation =  this.translate.get('msg');
    }

    ngOnInit() {
      const sub = this.activeRoute.params.subscribe(params => {
        this.account.firstLoginToken = params['id'];
      });
    }

    clickType() {
      if (this.styleInput === 'password') {
        this.styleIcon = '-slash';
        return this.styleInput = 'text';
      } else {
        this.styleIcon = '';
        return this.styleInput = 'password';
      }
    }

    onSubmit(): void {
      this.account.password = this.activateForm.value.password;
      this.ui.showSpinner(this.msgTranslation.loading_activation);
      this.authService.activate(this.account).subscribe(
          (response) => {
            if (response.outcome.success === true) {
              swal.fire(this.msgTranslation.value.pwd_sent, this.msgTranslation.value.activate_sent_ok, "success");
              this.router.navigate(['/login']);
            } else {
              swal.fire(this.msgTranslation.value.error, this.settings.manageErrorMsg(response.outcome), "error");
            }
          },
          (error) => {
            this.logger.log("Error", error, 200);
            this.errorMessage = this.errorTranslation.value.generic_error + ". " + this.errorTranslation.value.try_again;
            swal.fire(this.msgTranslation.value.error, this.errorMessage, "error");
          }
        );
      }
  }